<ion-card class="card-box" [class.card-box--overview]="variant() === 'overview'">
  @if (variant() === 'overview') {
    <ion-card-content class="card-box__overview">
      @for (card of overviewCards(); track card.title) {
        <article class="card-box__overview-card">
          <div class="card-box__overview-content">
            <p class="card-box__overview-title">{{ card.title }}</p>
            <p class="card-box__overview-amount">{{ card.amount }}</p>
            @if (card.approx) {
              <p class="card-box__overview-approx">{{ card.approx }}</p>
            }
            @if (card.hint) {
              <p class="card-box__overview-hint">{{ card.hint }}</p>
            }
          </div>

          <div class="card-box__overview-icon-wrap">
            <ion-icon class="card-box__overview-icon" [name]="card.icon"></ion-icon>
          </div>
        </article>
      }
    </ion-card-content>
  } @else {
    <ion-card-header>
      <ion-card-title *ngIf="!!title()">{{ title() }}</ion-card-title>
      <ion-card-subtitle *ngIf="!!subtitle()">{{ subtitle() }}</ion-card-subtitle>
      <ion-icon
        *ngIf="!!assetImage()"
        [src]="assetImage()"
        size="large"
        alt="asset"
        class="card-box__asset-image"
      />
    </ion-card-header>

    <ion-card-content class="card-box__content">
      <ng-content></ng-content>
    </ion-card-content>
  }
</ion-card>
